import { faArrowLeft, faPlus, faChevronLeft, faChevronRight, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect, useRef } from 'react';
import { Badge, Row, Col, Form, Button, Modal, Table } from 'react-bootstrap';
import Header from "../../../../Components/Header/Header.js";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu.js';
import bin from "../../../../assets/images/bin.png";
import { Step, StepLabel, Stepper } from '@mui/material';
import firstImage from '../../../../assets/images/warehouse.png';
import secondImage from '../../../../assets/images/information.png';
import { withToken } from '../../../../Services/axios.js';
import { SLOTPLANNINGAVAILABLESLOTCOUNT, SLOTPLANNINGAVAILABLESLOT, SLOTPLANNINGWAREHOUSE } from '../../../../Utils/conts.js';
import Docmnt from '../../../../assets/images/google-docs.png';
import Trash from "../../../../assets/images/trash.png";
import { Link } from 'react-router-dom';
import Overview from '../../../Airline/ULDControl/components/inc/Overview';
import Select from 'react-select';
import { withRFSToken } from '../../../../Services/axios.js';
import { toast } from 'react-toastify';
import { CallApi, jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
const PlanTrip = ({ onBack }) => {

    const [activeStep, setActiveStep] = useState(0);
    const [topbarData, setTopbarData] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [isLoader, setIsLoader] = useState(false);
    const [handlerNames, setHandlerNames] = useState([]);
    const [getDestination, setGetDestination] = useState([]);
    const [selectedHandler, setSelectedHandler] = useState(null);
    const [addressModalShow, setAddressModalShow] = useState(false);
    const addressModalClose = () => setAddressModalShow(false);
    const [warehouselist, setWarehouselist] = useState([]);
    const [handlerList, setHandlerList] = useState([]);
    const steps = [
        { label: (<>ULD Stock</>), icon: <img src={firstImage} /> },
        { label: (<>Trip Information</>), icon: <img src={secondImage} /> },
    ];



    // useEffect(() => {
    //     fetchWareHouseData(selectedHandler?.org_station_id);
    // }, [selectedHandler]);

    // const fetchWareHouseData = async (org_station_id) => {
    //     try {
    //         const res = await withRFSToken.post(SLOTPLANNINGWAREHOUSE, { org_station_id: org_station_id });
    //         const innerData = res.data.response_data;
    //         setWarehouselist(innerData.map(w => ({
    //             label: w.name,
    //             value: w.id,
    //             doors_count: w.doors_count,
    //         })));
    //     } catch (error) {
    //         console.error('Error fetching warehouse data:', error);
    //     }
    // };

    const stepNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    const stepBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const stepCancel = () => {
        // if (back_url === 'US') {
        //     window.location.href = '/ULDForwarder/ULDStock';
        // } else {
        //     window.location.href = "/ULDForwarder/ActiveTrips"
        // }
        ;
    };

    const back_url = localStorage.getItem('back_plan')

    const handleFinish = async () => {
        console.log("khskdbs");
        // setIsLoader(true);
        // console.log("booking slot==>",localFormData.bookingslot_time);
        if (!formData.handler_id || !formData.station_name) {
            toast.error('Please fill in both Station Code and Handler Name before proceeding!');
            setActiveStep(0);  // Navigate back to step 0
            return;
        }

        // Update formData with transformed ulds
        const updatedFormData = {
            ...formData,
            ulds: formData.ulds.map(({ uld_number, condition_code, ...rest }) => rest)
        };

        // setFormData(updatedFormData);

        // console.log('Updated Form Data:', formData);
        // console.log('imglist==>', files);
        CallApi({
            endPoint: 'forwarder-uld-control/assign-to-trip',
            payload: formData,
            onSuccess: (data) => {
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    toast.success(data.data.response_msg)
                    const innerData = data.data.response_data;
                    onBack()
                } else {
                    toast.error(data.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
        // try {
        //     // API Call
        //     const res = await withRFSToken.post('forwarder-uld-control/assign-to-trip', formData);

        //     if (res.data.response_code == 200) {
        //         toast.success('ULDs assigned successfully!');

        //     } else {
        //         toast.error(res.data.response_msg || 'Failed to assign ULDs.');
        //         setIsLoader(false);
        //     }
        // } catch (error) {
        //     console.error("Error assigning ULDs:", error);
        //     toast.error('Something went wrong while assigning ULDs.');
        // }
    }

    const isMounted = useRef(false);
    const isMount = useRef(false);
    const gridRef = useRef(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [disabledF, setDisabledF] = useState(false);
    const [formData, setFormData] = useState({ ulds: [] });

    const fetchDestination = async (stn) => {
        try {

            const res = await withRFSToken.post('uld-from/get-forwarder-origin', {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.value,
                        label: item.label,
                        handler_name: item.handler_name,
                        portCodeName: item.portCodeName
                    })) : [];
                    setGetDestination(innerData);
                    if (stn?.station_name) {
                        const checkStn = innerData.find(item => item.value === stn.station_name)
                        console.log('stn', checkStn);

                        setFormData(prevFormData => ({
                            ...prevFormData,
                            station_id: checkStn.port_Id
                        }));
                        // ({ ...formData, station_id: checkStn.port_Id, })
                        fetchHandler(stn?.station_name, stn?.handler_id);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchHandler = async (stationCode, handlr) => {
        try {
            const res = await withRFSToken.post('uld-from/get-forwarder-handler', { station_code: stationCode });
            const innerData = res.data.response_data;
            setHandlerList(innerData);
            if (innerData.length == 1) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    handler_id: innerData[0].value,
                    warehouse_id: innerData[0].warehouse_id
                }));
                setSelectedHandler({ label: innerData[0].label, value: innerData[0].value })
            }
            if (handlr) {
                const matchingHandler = innerData.find(handler => handler.value === Number(handlr));
                setSelectedHandler({ label: matchingHandler.label, value: matchingHandler.value })
                // setFormData({ ...formData, handler_id: matchingHandler.value, warehouse_id: matchingHandler.warehouse_id })
                setFormData(prevFormData => ({
                    ...prevFormData,
                    handler_id: matchingHandler.value,
                    warehouse_id: matchingHandler.warehouse_id
                }));
            }

            setHandlerNames(innerData);

            // return innerData;
        } catch (error) {
            console.error('Error fetching handler data:', error);
            return [];
        }
    };

    const localData = JSON.parse(localStorage.getItem('plan_trip'));
    useEffect(() => {
        // check_edit();
        if (isMounted.current) return;

        if (localData) {
            setFormData(localData)
            setDisabledF(true);
        }
        fetchDestination(localData);
        // fetchHandler(localData?.station_name, localData?.handler_id);
        setIsLoading(false);
        setGridData([]);

        isMounted.current = true;
    }, []);

    let checkUlds = [];
    useEffect(() => {
        if (gridRef?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();
            let tabType = '';
            // if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
            // const endpoint = tabType === 'A' 
            //     ? 'uld-control/active-uld-planning' 
            //     : 'uld-control/archive-uld-planning';
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'uld_id', type: 'string' },
                    { name: 'created', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'type_code', type: 'string' },
                    { name: 'serial_number', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'sender_handler', type: 'string' },
                    { name: 'airline', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'on_loan', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'status', type: 'string' },
                    { name: 'archive_date', type: 'string' },
                    { name: 'condition_code', type: 'string' },
                    { name: 'handler_organisation', type: 'string' },
                    { name: 'luc_out', type: 'string' },

                    { name: 'handlerOrgId', type: 'string' },
                    { name: 'assigned', type: 'string' },

                ],
                // id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}forwarder-uld-control/active-ulds?tab_name=A`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function () {
                    // if (allfilters.length > 0) {
                    //     setFilterApplied(true);
                    //     filterForCheck = true;
                    // } else {
                    //     setFilterApplied(false);
                    //     filterForCheck = false;
                    // }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [

                { text: 'ULD Number', filtertype: 'textbox', datafield: 'uld_number', width: '28%', cellclassname: '', },

                { text: 'Type Code', filtertype: 'textbox', datafield: 'type_code', width: '12%', cellclassname: '', },
                { text: 'Serial Number', filtertype: 'textbox', datafield: 'serial_number', width: '15%', cellclassname: '', },
                { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '12%', cellclassname: '', },
                {
                    text: 'Handler Name', filtertype: 'textbox', datafield: 'handler_organisation', width: '28%', cellclassname: '',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.handler_organisation) {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">' + rowdata.handler_organisation.org_Name + '</div>';
                        } else {
                            return '<div class="jqx-grid-cell-left-align" style="margin-top:13px;">  </div>';
                        }
                    }
                },


            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 750,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['20', '50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }

                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });


        }
    }, [gridData, activeStep]);



    // const handleAddUld = () => {
    //     if (gridSelect.length === 0) {
    //         toast.error('Please select ULD first!');
    //         return;
    //     }

    //     const referenceOriginCompany = formData.handler_id ? formData.handler_id : gridSelect[0].luc_out;

    //     const referenceStation = formData.station_name ? formData.station_name : gridSelect[0].origin;

    //     const isValidSelection = gridSelect.every(uld => uld.luc_out === referenceOriginCompany);
    //     const isValidStationSelection = gridSelect.every(uld => uld.origin ?? uld.handler_station_code === referenceStation);
    //     // const referencehandlerOrgId = formData.ulds.length > 0 ? formData.ulds[0].handlerOrgId : gridSelect[0].handlerOrgId
    //     // const isValidhandlerOrgId = gridSelect.every(uld => uld.handlerOrgId === referencehandlerOrgId)
    //     if (!isValidSelection && !isValidStationSelection) { //!isValidSelection && !isValidStationSelection
    //         toast.dismiss();
    //         toast.error('All selected ULDs must have the same Origin Company and Handler!');
    //         return;
    //     }

    //     // Extract only the required fields from formData.ulds
    //     const existingUldNumbers = new Set(formData.ulds.map(uld => uld.uld_number));

    //     // Extract only required fields from gridSelect and filter duplicates
    //     const filteredUlds = gridSelect
    //         .filter(uld => !existingUldNumbers.has(uld.uld_number))
    //         .map(({ id, uld_number, condition_code, type_code, serial_number, owner_code, airline, airway_bill, sender_handler, assigned, handlerOrgId }) => ({
    //             uld_id: id, uld_number, condition_code, type_code, serial_number, owner_code, airline_name1: airline, airway_bill, sender_handler, assigned, handlerOrgId
    //         }));

    //     if (filteredUlds.length !== gridSelect.length) {
    //         toast.error('Some selected ULDs have duplicate ULD numbers and were not added!');
    //     }

    //     if (filteredUlds.length === 0) {
    //         return;
    //     }

    //     setFormData(prevFormData => ({
    //         ...prevFormData,
    //         ulds: [...prevFormData.ulds, ...filteredUlds]
    //     }));

    //     gridSelect.forEach(selectedItem => {
    //         const selectedRowBoundIndex = selectedItem.boundindex;
    //         if (selectedRowBoundIndex !== undefined && selectedRowBoundIndex !== null) {
    //             window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
    //         }
    //     });
    // };

    const handleAddUld = async () => {
    if (gridSelect.length === 0) {
        toast.error('Please select ULD first!');
        return;
    }

    const referenceOriginCompany = formData.handler_id ? formData.handler_id : gridSelect[0].luc_out;
    const referenceStation = formData.station_name ? formData.station_name : gridSelect[0].origin;

    const isValidSelection = gridSelect.every(uld => uld.luc_out === referenceOriginCompany);
    const isValidStationSelection = gridSelect.every(uld => (uld.origin ?? uld.handler_station_code) === referenceStation);

    if (!isValidSelection && !isValidStationSelection) {
        toast.dismiss();
        toast.error('All selected ULDs must have the same Origin Company and Handler!');
        return;
    }
    let updatedFormData = { ...formData };

    if (!formData.station_name && gridSelect[0].origin) {
        const matchedStation = getDestination.find(opt => opt.value === gridSelect[0].origin);
        updatedFormData = {
            ...updatedFormData,
            station_name: gridSelect[0].origin,
            staion_id: matchedStation?.port_Id ?? '',
        };
    }

    if (!formData.handler_id && gridSelect[0].luc_out) {
       fetchHandler(gridSelect[0].origin, gridSelect[0].luc_out);
    }

    const existingUldNumbers = new Set(updatedFormData.ulds.map(uld => uld.uld_number));
    const filteredUlds = gridSelect
        .filter(uld => !existingUldNumbers.has(uld.uld_number))
        .map(({ id, uld_number, condition_code, type_code, serial_number, owner_code,
                 airline, airway_bill, sender_handler, assigned, handlerOrgId }) => ({
            uld_id: id, uld_number, condition_code, type_code, serial_number,
            owner_code, airline_name1: airline, airway_bill, sender_handler, assigned, handlerOrgId
        }));

    if (filteredUlds.length !== gridSelect.length) {
        toast.error('Some selected ULDs have duplicate ULD numbers and were not added!');
    }
    if (filteredUlds.length === 0) return;

    setFormData({
        ...updatedFormData,
        ulds: [...updatedFormData.ulds, ...filteredUlds]
    });

    gridSelect.forEach(selectedItem => {
        const selectedRowBoundIndex = selectedItem.boundindex;
        if (selectedRowBoundIndex !== undefined && selectedRowBoundIndex !== null) {
            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
        }
    });
};
    const removeDetails = (sec) => {
        console.log("sec:", sec);
        // setFormData(prevFormData => {
        //     const deletedIds = Array.isArray(prevFormData.deleted_ids) ? prevFormData.deleted_ids : [];    

        //     console.log("Deleting:", sec.uld_det_id);
        //     console.log("Before:", prevFormData.ulds.map(u => u.uld_det_id));

        //     const shouldAddToDeleted = !!sec.uld_receipt_det_id;

        //     return {
        //         ...prevFormData,
        //         ulds: prevFormData.ulds.filter(stack => stack.uld_det_id !== sec.uld_det_id),
        //         deleted_ids: shouldAddToDeleted ? [...deletedIds, sec] : deletedIds
        //     };
        // });
        setFormData(prevFormData => {
            const currentDeleted = Array.isArray(prevFormData.deleted_ids) ? prevFormData.deleted_ids : [];
            return {
                ...prevFormData,
                ulds: prevFormData.ulds.filter(stack => stack.uld_number !== sec.uld_number),
                deleted_ids: sec.uld_receipt_det_id ? [...currentDeleted, sec] : currentDeleted
            };
        });
    };




    //............................ booking time slot start........................
    //const [formData, setFormData] = useState({});

    const [localFormData, setLocalFormData] = useState({ bookingslot_date: '', bookingslot_time: '' });
    // useEffect(() => {
    //     setLocalFormData(formData);
    //     // getHandlerAddress();

    // }, []);//formData

    const [currentDate, setCurrentDate] = useState(new Date());
    const daysToShow = 7;



    function handleNext() {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() + daysToShow);
        setCurrentDate(newDate);
        setFormData(prev => {
            const { booking_slot_date, ...rest } = prev;
            return rest;
        });
    }

    function handlePrevious() {
        const newDate = new Date(currentDate);
        newDate.setDate(currentDate.getDate() - daysToShow);
        setCurrentDate(newDate);
        setFormData(prev => {
            const { booking_slot_date, ...rest } = prev;
            return rest;
        });
    }

    function handleDateChange(event) {
        const [year, month] = event.target.value.split('-').map(Number);
        const newDate = new Date(year, month - 1, 1);
        setCurrentDate(newDate);
        setFormData(prev => {
            const { booking_slot_date, ...rest } = prev;
            return rest;
        });
    }

    const [apiData, setApiData] = useState([]);
    const [bookingSlotsPast, setBookingSlotsPast] = useState([]);
    const [bookingSlotsPresent, setBookingSlotsPresent] = useState([]);
    const [bookingSlotsFuture, setBookingSlotsFuture] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());



    const countAvailableSlots = (date) => {
        // const formattedDate = date.toISOString().split('T')[0];
        // const slotsForDate = apiData[formattedDate] || [];
        // // console.log("🚀 ~ countAvailableSlots ~ slotsForDate:", slotsForDate);
        // const availableSlotsCount = slotsForDate.filter(slot => slot.status === 1).length;
        let availableSlotsCount = 0;
        allAvailableSlotCount.forEach(element => {
            if (date == element.date) {
                availableSlotsCount = element.available_no_of_slot;
            }
        });
        return availableSlotsCount;
    };

    function isSameDay(date1, date2) {
        return (
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate()
        );
    }

    const handleDayClick = (date) => {
        if (!apiData) {
            console.error('API data is not available');
            return;
        }

        // Convert the date to the format "YYYY-MM-DD"
        const formattedDate = date.toISOString().split('T')[0];

        // Retrieve the slots for the clicked date from the apiData object
        const slotsForDate = apiData[formattedDate] || [];

        // Update the state with the fetched slots
        setSelectedDate(date);  // Store the selected date
        const updatedData = { ...formData, booking_slot_time: "" };
        setFormData(updatedData);
        setBookingSlotsPast([]);
        setBookingSlotsPresent([]);
        setBookingSlotsFuture([]);
        // Update formData with the selected date
        // setFormData(prev => ({
        //     ...prev,
        //     booking_slot_date: formattedDate  // Store in 'YYYY-MM-DD' format
        // }));
    };


    const [selectedSlot, setSelectedSlot] = useState({ type: '', index: null });
    const [messageText, setMessageText] = useState('');
    const handleSlotClick = (type, index) => {
        // setSelectedSlotId(index);
        // setFormData({ ...formData, slot: showBookingSlots[index] });
        setSelectedSlot({ type, index });
        const slotList = type === 'past' ? bookingSlotsPast : bookingSlotsFuture;
        setFormData({ ...formData, slot: slotList[index] });
    };

    function getDayName(date) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        return days[date.getDay()];
    }

    function getMonthYearOptions() {
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const currentYear = new Date().getFullYear();
        const options = [];
        for (let year = currentYear - 1; year <= currentYear + 1; year++) {
            for (let month = 1; month <= 12; month++) {
                options.push(<option key={`${year}-${month}`} value={`${year}-${month}`}>{months[month - 1]} {year}</option>);
            }
        }
        return options;
    }

    function isCurrentDate(date) {
        const today = new Date();
        return date.toDateString() === today.toDateString();
    }

    //................................. image upload.................................
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const [dateList, setDateList] = useState([]);
    const [warehouseId, setWarehouseId] = useState();
    const [allAvailableSlotCount, setAllAvailableSlotCount] = useState([]);
    const [handlerDoorConfig, setHandlerDoorConfig] = useState();

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });

        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);

            // Update local storage
            setFormData((prevFormData) => {
                const newFormData = { ...prevFormData, attachments: newBase64Files };
                return newFormData;
            });

            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        const existingBase64Files = formData.attachments || [];
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result });
                if (filesWithBase64.length === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file.name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    setBase64Files(mergedBase64Files);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => obj.file)]);
                    setFormData(prevFormData => ({ ...prevFormData, files: mergedBase64Files }));
                }
            };
            reader.readAsDataURL(file);
        });
    }


    // console.log("base64Files ==> 1195 ", base64Files);
    // localStorage.setItem("img", JSON.stringify(base64Files));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        if (name == "booking_slot_datetime") {
            availableSlot(value);
        }
    };

    const availableSlot = async (value) => {

        try {
            const dateVal = selectedDate.toISOString().split('T')[0];
            const timeVal = value;
            const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOT, {
                "warehouse_id": formData.warehouse_id,
                "date": dateVal,
                "time": timeVal,
                "cargo_type_id": 3,
                "trip_type_id": 8,
            });
            if (res.data.response_code == 200) {
                const { recentBefore, recentSlots, upcomingAfter } = res.data.response_data;
                setSelectedSlot({ type: '', index: null });
                setBookingSlotsPast(recentBefore);
                setBookingSlotsPresent(recentSlots);
                setBookingSlotsFuture(upcomingAfter);
                if (res.data.response_data.recentSlots.door_id) {
                    setFormData(prev => ({
                        ...prev,
                        booking_slot_time: value,
                        slot: [],
                        ...(recentSlots?.door_id ? { slot: recentSlots } : {})
                    }));
                    setMessageText('');
                } else {
                    setFormData(prev => ({
                        ...prev,
                        booking_slot_time: value,
                    }));
                    setMessageText('No timeslot is currently available at your selected time. Please choose from the closest available timeslots below.');
                }
                // } else if (res.data.response_code == 400) {
                //     setMessageText(res.data.response_msg);
                //     setFormData(prev => ({
                //         ...prev,
                //         booking_slot_time: value,
                //     }));
            } else {
                // toast.success(res.data.response_msg);
                setFormData(prev => ({
                    ...prev,
                    booking_slot_time: value,
                }));
            }
        } catch (error) {
            console.error('Error fetching warehouse data:', error);
        }
    }
    const availableSlotCount = async (dates) => {
        const startDate = dates[0].toISOString().split('T')[0];
        const endDate = dates[dates.length - 1].toISOString().split('T')[0];
        try {
            const res = await withRFSToken.post(SLOTPLANNINGAVAILABLESLOTCOUNT, {
                "warehouse_id": formData.warehouse_id,
                "start_date": startDate,
                "end_date": endDate,
                "cargo_type_id": 3,
                "trip_type_id": 8,
            });
            if (res.data.response_code == 200) {
                setAllAvailableSlotCount(res.data.response_data);
            } else {
                // toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error fetching warehouse data:', error);
        }
    }

    const calculateTimeRange = (arrivalTimeStr) => {
        if (!arrivalTimeStr) return "";

        const arrival = new Date(arrivalTimeStr);
        const start = new Date(arrival.getTime() + 15 * 60000); // +15 min
        console.log('sss', start.toLocaleDateString());

        const end = new Date(start.getTime() + 60 * 60000);     // +1 hour

        const formatTime = (date) =>
            date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

        return `${formatTime(start)} - ${formatTime(end)}`; // ${start.toISOString().split('T')[0]}
    };

    const check_edit = () => {
        const planTrip = localStorage.getItem('plan_trip');
        { console.log("inside check edit function ", planTrip) }
        const editULD = localStorage.getItem('EditFULD');

        const action = (planTrip || editULD) ? 'E' : 'P';

        setFormData(prev => ({
            ...prev,
            action
        }));
    };

    useEffect(() => {
        const dates = generateDateRange(currentDate, 7); // 7 days
        setDateList(dates);
        if (formData.handler_id)
            availableSlotCount(dates);
    }, [currentDate, warehouseId]);

    const generateDateRange = (startDate, days) => {
        const dates = [];
        for (let i = 0; i < days; i++) {
            const newDate = new Date(startDate);
            newDate.setDate(startDate.getDate() + i);
            dates.push(newDate);
        }
        return dates;
    };

    const handleHandlerChange = (selected) => {
        // const updatedData = { ...formData, handler_id: selected.value, warehouse_id: selected.warehouse_id };
        // setFormData(updatedData);
        // setSelectedHandler(selected);
        // setHandlerDoorConfig(selected.door_configuration);
        // setWarehouseId(selected.warehouse_id);
        setFormData(prev => ({
            ...prev,
            handler_id: selected.value,
            warehouse_id: selected.warehouse_id,
            booking_slot_time: '',
            slot: [],
        }));
        setSelectedHandler(selected);
        setHandlerDoorConfig(selected.door_configuration);
        setWarehouseId(selected.warehouse_id);
        setMessageText('');
        setBookingSlotsPast([]);
        setBookingSlotsPresent([]);
        setBookingSlotsFuture([]);
    };

    const formatTime = (datetime) => {
        return new Date(datetime).toLocaleTimeString('en-IN', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        });
    };

    const formatDate = (datetime) => {
        return new Date(datetime).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short', // e.g., Sep
        });
    };
    return (
        <>
            {/* <div className="">

                <Header />
                <div className="page-body-wrapper schedule">
                    <LeftMenu /> */}
            {/* {console.log('formData', formData)}
            {console.log('gridSelect', gridSelect)} */}
            <div className="main-panel rounded">
                <Link to='#' onClick={() => onBack(true)} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                <div className="mainTab">
                    <div className='w-75 mx-auto'>
                        <div className="allcontent-fl">
                            <div className="lcontent">
                                <div className="mb-3 nestedtabs rounded">
                                    <div className='d-flex justify-content-between'>
                                        <div className='d-flex'>
                                            <div className='viewbook'>
                                                <h4>Receipt Number - {localData?.control_receipt_numb} </h4>
                                                <p><b>Date : {localData?.planned_transfer_date}</b>  <span style={{ marginLeft: '10px', marginRight: '10px', }}><b>Time Slot: {localData?.planned_slot}</b> </span> <b>Door : {localData?.door}</b> </p>
                                            </div>
                                        </div>
                                        <div className='d-flex'>
                                            <div className='ulddown'>
                                                <button ><img src={bin} /> Delete Trip</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='w-75 mx-auto'>
                                    <Stepper activeStep={activeStep} alternativeLabel className="tracorder_step">
                                        {steps.map(({ label }, index) => (
                                            <Step key={index} onClick={() => setActiveStep(index)} className="cursor-pointer">
                                                <StepLabel>{label}</StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>
                                </div>
                                <div>
                                    {isLoader &&
                                        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
                                    }
                                    {activeStep === 0 &&
                                        <>
                                            <Row>
                                                <Col sm='6'>
                                                    <div className="nestedtabs rounded charter_top charter_from" >
                                                        <h3>Returning To</h3>
                                                        <Form.Group as={Row} className="mb-3" controlId="acn">
                                                            <Col sm="5">
                                                                <label className="form-label" >Station Code <span>*</span></label>
                                                                <Select
                                                                    options={getDestination}
                                                                    onChange={(selected) => {
                                                                        const selectedDestination = getDestination.find(option => option.value === selected.value);
                                                                        // console.log("🚀 ~ Selected Station:", selectedDestination);

                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            station_name: selected.value,
                                                                            staion_id: selected.port_Id,
                                                                            handler_id: '',
                                                                            booking_slot_time: '',
                                                                            slot: [],
                                                                        }));
                                                                        setMessageText('');
                                                                        setBookingSlotsPast([]);
                                                                        setBookingSlotsPresent([]);
                                                                        setBookingSlotsFuture([]);
                                                                        setHandlerNames([]);
                                                                        setSelectedHandler(null);

                                                                        if (selectedDestination) {
                                                                            fetchHandler(selectedDestination.value); // Fetch handlers
                                                                        }
                                                                    }}
                                                                    placeholder="Station"
                                                                    className="autoslct w-100"
                                                                    name="station_name"
                                                                    isDisabled={disabledF}
                                                                    value={getDestination.find(option => option.value === formData.station_name)}
                                                                />

                                                            </Col>
                                                            <Col sm="5">
                                                                <label className="form-label">Handler Name <span>*</span></label>

                                                                <Select
                                                                    options={handlerNames}
                                                                    onChange={handleHandlerChange}
                                                                    placeholder="Handler Name"
                                                                    className="autoslct me-0 w-100"
                                                                    name="handler_id"
                                                                    value={selectedHandler ? { value: selectedHandler.value, label: selectedHandler.label } : null}
                                                                    isDisabled={!handlerNames.length || disabledF}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                    </div>
                                                    <div className='mb-3 mt-3 nestedtabs rounded h-81'>
                                                        <div className='d-flex justify-content-between charter_top'>
                                                            <h3>ULD Details</h3>
                                                            <span className="selected">
                                                                Selected ULD <Badge>{formData.ulds.length}</Badge>
                                                            </span>
                                                        </div>
                                                        <div className='table-responsive repar_h'>
                                                            <Table className='uld_details ra_repair'>
                                                                <thead>
                                                                    <tr>
                                                                        <th>ULD Number</th>
                                                                        <th>Type Code</th>
                                                                        <th>Serial Number</th>
                                                                        <th>Owner Code</th>
                                                                        <th>Condition Code</th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {formData && formData.ulds.map((section, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td><Form.Control type="text" readOnly value={section.uld_number} onChange='' /></td>
                                                                                <td><Form.Control type="text" readOnly value={section.type_code} onChange='' /></td>
                                                                                <td><Form.Control type="text" readOnly value={section.serial_number} onChange='' /></td>
                                                                                <td><Form.Control type="text" readOnly value={section.owner_code} onChange='' /></td>
                                                                                <td><Form.Control type="text" readOnly value={section.condition_code} onChange='' /></td>
                                                                                <td>
                                                                                    <img src={Trash} onClick={() => removeDetails(section)} />
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col sm='6'>
                                                    {!isLoading &&
                                                        <div className='mb-3 nestedtabs rounded'>
                                                            <div className='d-flex justify-content-between charter_top'>
                                                                <h3>ULD Stock</h3>
                                                                <span className="selected">
                                                                    Selected ULD <Badge>{gridSelect.length}</Badge>
                                                                </span>
                                                            </div>
                                                            <div ref={gridRef} className='ovgrid' ></div>
                                                            <div className='text-center mt-3'><Button variant="primary" className='aduld' onClick={handleAddUld}>  ADD TO TRIP  </Button></div>
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>



                                        </>
                                    }
                                    {activeStep === 1 &&
                                        <Row>
                                            <Col sm='6'>
                                                <div className="nestedtabs rounded charter_top h-100 px-4 bookig_slot" >
                                                    <h4>Booking Slot</h4>
                                                    <div className="calendar-container d-none">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className='recent_time'>
                                                                <h5>{new Date(selectedDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</h5>

                                                                {/* <Select
                                                                        name="warehouse_id"
                                                                        options={warehouselist}
                                                                        value={warehouselist?.find(opt => opt.value === formData.warehouse_id)}
                                                                        disabled={handlerDoorConfig === 0}
                                                                        onChange={(selected) => {
                                                                            const updatedData = { ...formData, warehouse_id: selected.value, booking_slot_time: "" };
                                                                            setFormData(updatedData);
                                                                            setWarehouseId(selected.value);
                                                                        }}
                                                                        placeholder="Warehouse"
                                                                    /> */}
                                                            </div>
                                                            <div>
                                                                <button className='btnleft' onClick={handlePrevious}> <FontAwesomeIcon icon={faChevronLeft} /> </button>
                                                                <button className='btnright' onClick={handleNext}> <FontAwesomeIcon icon={faChevronRight} /> </button>

                                                            </div>
                                                        </div>
                                                        <div className="scrollable-calendar mb-4 mt-3">
                                                            {/* {[...Array(daysToShow)].map((_, index) => {
                                                                    const date = new Date(currentDate);
                                                                    date.setDate(currentDate.getDate() + index);
                                                                    return (
                                                                        <div key={index} className={`day ${isCurrentDate(date) ? 'current-date' : ''} ${selectedDate && isSameDay(date, selectedDate) ? 'active' : ''}`} onClick={() => handleDayClick(date)}>
                                                                            <div className="day-name">{getDayName(date)}</div>
                                                                            <div className="date">{date.getDate()}</div>
                                                                            <div className='slot'> <span></span> {countAvailableSlots(date)} slots </div>

                                                                        </div>
                                                                    );
                                                                })} */}

                                                            {dateList.map((date, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`day ${isCurrentDate(date) ? 'current-date' : ''} ${selectedDate && isSameDay(date, selectedDate) ? 'active' : ''}`}
                                                                    onClick={() => handleDayClick(date)}
                                                                >
                                                                    <div className="day-name">{getDayName(date)}</div>
                                                                    <div className="date">{date.getDate()}</div>
                                                                    <div className='slot'> <span></span> {countAvailableSlots(date.toISOString().split('T')[0])} slots </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className='d-flex mb-3'>
                                                            <div className='planed_time'>
                                                                <label>Planned Time</label>
                                                                <Form.Group>
                                                                    <input
                                                                        type="time" name="booking_slot_time" id='datetime' className='form-control' disabled={handlerDoorConfig != 1}
                                                                        value={formData.booking_slot_time} dateFormat="yyyy-MM-dd" onChange={handleInputChange}
                                                                    />
                                                                </Form.Group>
                                                            </div>

                                                            <div className='notavail_door'>
                                                                <h3 className='text-danger'>
                                                                    {messageText}
                                                                </h3>
                                                            </div>
                                                            {bookingSlotsPresent?.door_id && (
                                                                <div className='avail_door'>
                                                                    <p>Available - {bookingSlotsPresent.door_no}</p>
                                                                    <span>
                                                                        Timeslot - {formatTime(bookingSlotsPresent.start_time)} to {formatTime(bookingSlotsPresent.end_time)}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {bookingSlotsPast.length > 0 && (
                                                            <div className='avalable'>
                                                                <h2>Earlier Timeslot</h2>
                                                                <div className="timeslot">
                                                                    {bookingSlotsPast.map((slot, index) => (
                                                                        <div
                                                                            key={`past-${index}`}
                                                                            className={`available time ${selectedSlot.type === 'past' && selectedSlot.index === index ? 'selected' : ''}`}
                                                                            onClick={() => handleSlotClick('past', index)}
                                                                        >
                                                                            <h4>{slot.door_no}</h4>
                                                                            {new Date(slot.start_time).toDateString() !== new Date(slot.end_time).toDateString() ? (
                                                                                <>
                                                                                    <p>{formatDate(slot.start_time)} - {formatDate(slot.end_time)}</p>
                                                                                    <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <p>{formatDate(slot.start_time)}</p>
                                                                                    <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {bookingSlotsFuture.length > 0 && (
                                                            <div className='avalable'>
                                                                <h2>Later Timeslot</h2>
                                                                <div className="timeslot">
                                                                    {bookingSlotsFuture.map((slot, index) => (
                                                                        <div
                                                                            key={`future-${index}`}
                                                                            className={`available time ${selectedSlot.type === 'future' && selectedSlot.index === index ? 'selected' : ''}`}
                                                                            onClick={() => handleSlotClick('future', index)}
                                                                        >
                                                                            <h4>{slot.door_no}</h4>
                                                                            {new Date(slot.start_time).toDateString() !== new Date(slot.end_time).toDateString() ? (
                                                                                <>
                                                                                    <p>{formatDate(slot.start_time)} - {formatDate(slot.end_time)}</p>
                                                                                    <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    <p>{formatDate(slot.start_time)}</p>
                                                                                    <p>{formatTime(slot.start_time)} - {formatTime(slot.end_time)}</p>
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className='planed_time w-75 mt-3'>
                                                        <label>Planned Transfer Date/Time</label>
                                                        <Form.Group as={Row} className="mb-1" >
                                                            <Col sm="6" >
                                                                <input
                                                                    type="datetime-local" name="booking_slot_datetime" id='datetime' className='form-control'
                                                                    value={formData.booking_slot_datetime} dateFormat="yyyy-MM-dd" onChange={handleInputChange}
                                                                // maxLength='4' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 4); }}
                                                                />
                                                            </Col>
                                                            <Col sm="6" className=''>
                                                                <input
                                                                    type="text" className="form-control" value={calculateTimeRange(formData.booking_slot_time)} disabled
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                    </div>
                                                </div>

                                            </Col>
                                            <Col sm='6'>
                                                <div className="nestedtabs rounded charter_top px-4 trip_info" >
                                                    <h3>Trip Information</h3>
                                                    <Form className='charter_from w-75'>
                                                        <Form.Group as={Row} className="mb-2" controlId="name">

                                                            <Col sm="6">
                                                                <Form.Label>Driver Name</Form.Label>
                                                                <Form.Control type="text"
                                                                    name="driver_name"
                                                                    value={formData.driver_name}
                                                                    onChange={handleInputChange} />

                                                            </Col>
                                                            <Col sm="6">
                                                                <Form.Label>Trucking Company</Form.Label>
                                                                <Form.Control type="text"
                                                                    name="trucking_company"
                                                                    value={formData.trucking_company}
                                                                    onChange={handleInputChange} />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" controlId="acn">

                                                            <Col sm="6">
                                                                <Form.Label>ACN ID</Form.Label>
                                                                <Form.Control type="text"
                                                                    name="acn_id"
                                                                    value={formData.acn_id}
                                                                    onChange={handleInputChange} />
                                                            </Col>
                                                            <Col sm="6">
                                                                <Form.Label>Vechile ID</Form.Label>
                                                                <Form.Control type="text"
                                                                    name="vehicle_id"
                                                                    value={formData.vehicle_id}
                                                                    onChange={handleInputChange} />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" controlId="tailer">
                                                            <Col sm="6">
                                                                <Form.Label>Trailer ID</Form.Label>
                                                                <Form.Control type="text"
                                                                    name="trailer_id"
                                                                    value={formData.trailer_id}
                                                                    onChange={handleInputChange} />
                                                            </Col>
                                                            <Col sm="6">
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-2" controlId="remarks">
                                                            <Col sm="12">
                                                                <Form.Label>Remarks</Form.Label>
                                                                <Form.Control as="textarea" rows={3}
                                                                    name="remarks"
                                                                    value={formData.remarks}
                                                                    onChange={handleInputChange} />
                                                            </Col>
                                                        </Form.Group>

                                                        <div className='steper_upfile'>
                                                            <Form.Label>Upload Images/Documents</Form.Label>
                                                            <div
                                                                className='dropfile'
                                                                onDrop={handleDrop}
                                                                onDragOver={handleDragOver}
                                                            >
                                                                <h3>Drag and drop files here</h3>
                                                                <button className='btn btn-primary drpbtn' onClick={handleBrowseFiles}>Browse Files</button>
                                                                <span className='mt-0'>Maximum file size 4 MB</span>
                                                                <input
                                                                    type="file"
                                                                    ref={fileInputRef}
                                                                    style={{ display: 'none' }}
                                                                    onChange={handleFileChange}
                                                                    multiple
                                                                />
                                                            </div>
                                                            <div className='uploadbox'>
                                                                {files.map((file, index) => (
                                                                    <div key={index} className='uploadfil'>
                                                                        {file.type.startsWith('image/') ? (
                                                                            <img
                                                                                src={URL.createObjectURL(file)}
                                                                                alt="Preview"
                                                                                style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                            />
                                                                        ) : (
                                                                            <span className='d-flex'><img src={Docmnt} className='fileimg' /> {file.name}</span>
                                                                        )}
                                                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                    </Form>


                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                    <div className='ordernext'>
                                        <Button onClick={activeStep > 0 ? stepBack : onBack} variant="contained">{/* disabled={activeStep === 0 || false} */}
                                            {activeStep > 0 ? 'Back' : 'Cancel'}
                                        </Button>
                                        <Button className='trnext' variant="contained" onClick={activeStep === steps.length - 1 ? handleFinish : stepNext}>
                                            {activeStep === steps.length - 1 ? 'Submit' : 'Next'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </div> */}
            {/* 
            <Modal show={addressModalShow} onHide={addressModalClose} centered className='addfrom'>
                <Modal.Header closeButton onClick={addressModalClose}>
                    <Modal.Title>Add Address  - {destLabel}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Form.Group className='mb-2'>
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control type="text" onChange={handleAddressChange} name='company_name' placeholder="Company Name" />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Agent or Handler</Form.Label>
                        <Form.Check
                            inline
                            label="Agent"
                            name="agent_or_handler"
                            type='radio'
                            id='export'
                            value='A'
                            checked={inputAddress.agent_or_handler === 'A'}
                            onChange={handleAddressChange}
                            disabled
                        />

                        <Form.Check
                            inline
                            label="Handler"
                            value="H"
                            name="agent_or_handler"
                            type='radio'
                            id='import'
                            checked={inputAddress.agent_or_handler === 'H'}
                            onChange={handleAddressChange}
                        />
                    </Form.Group>
                    {inputAddress.agent_or_handler == 'A' &&
                        <>
                            <Form.Group className='mb-2'>
                                <Form.Check
                                    inline
                                    label="External"
                                    name="agent_type"
                                    type='radio'
                                    id='external'
                                    value='E'
                                    checked={inputAddress.agent_type === 'E'}
                                    onChange={handleAddressChange}
                                />

                                <Form.Check
                                    inline
                                    label="Internal"
                                    value="I"
                                    name="agent_type"
                                    type='radio'
                                    id='internal'
                                    checked={inputAddress.agent_type === 'I'}
                                    onChange={handleAddressChange}
                                />

                            </Form.Group>
                        </>
                    }
                    <Form.Group className='mb-2'>
                        <Form.Label>Address </Form.Label>
                        <Form.Control type="text" onChange={handleAddressChange} name='address' placeholder="Address" />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Email ID</Form.Label>
                        <Form.Control type="text" onChange={handleAddressChange} name='email' placeholder="E-mail" />
                    </Form.Group>
                    <Form.Group className='mb-2'>
                        <Form.Label>Telephone No</Form.Label>
                        <Form.Control type="number" onChange={handleAddressChange} name='phone_number' onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 12); }} placeholder="Number" />
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addAddress}  >
                        Add Address
                    </Button>
                </Modal.Footer>
            </Modal> */}
            {/* </div> */}
        </>
    )
}

export default PlanTrip